import React, { useEffect, useRef, useState } from 'react';
import { Send, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function Thread({ path, me, onRead, onCount }) {
  const [msgs, setMsgs] = useState(null);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const end = useRef(null);
  useEffect(() => {
    fetch(`${API_URL}/api${path}`, { credentials: 'include' }).then((r) => (r.ok ? r.json() : [])).then((m) => { setMsgs(m); onRead?.(); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);
  useEffect(() => { end.current?.scrollIntoView({ block: 'nearest' }); }, [msgs]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    const r = await fetch(`${API_URL}/api${path}`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ text }) });
    setBusy(false);
    if (!r.ok) { toast.error("Le message n'a pas pu être envoyé"); return; }
    const m = await r.json();
    setMsgs((l) => { const n = [...(l || []), m]; onCount?.(n.length); return n; });
    setText('');
  };

  return (
    <div className="border border-white/10 bg-[#101010]" data-testid="message-thread">
      <div className="max-h-72 overflow-y-auto p-4 space-y-3">
        {!msgs && <Loader2 className="w-4 h-4 animate-spin text-[#a68966]" />}
        {msgs && msgs.length === 0 && <p className="text-xs text-gray-500">Aucun message pour l'instant. Posez votre question, nous vous répondons rapidement.</p>}
        {msgs?.map((m) => {
          const mine = m.author === me;
          return (
            <div key={m.id} className={`flex ${mine ? 'justify-end' : 'justify-start'}`} data-testid={`message-${m.author}`}>
              <div className={`max-w-[85%] px-4 py-2.5 text-sm leading-relaxed ${mine ? 'bg-[#a68966] text-[#1a1a1a]' : 'bg-[#1f1f1f] text-gray-200 border-l-2 border-[#4dffb8]/60'}`}>
                <p className={`text-[10px] uppercase tracking-[0.2em] mb-1 ${mine ? 'text-[#1a1a1a]/70' : 'text-[#a68966]'}`}>{m.name} · {new Date(m.timestamp).toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</p>
                <p className="whitespace-pre-wrap">{m.text}</p>
              </div>
            </div>
          );
        })}
        <div ref={end} />
      </div>
      <form onSubmit={send} className="flex border-t border-white/10">
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} maxLength={3000} placeholder="Écrire un message..." data-testid="message-input"
          className="flex-1 bg-transparent text-sm text-gray-200 px-4 py-3 outline-none resize-none placeholder:text-gray-600" />
        <button type="submit" disabled={busy || !text.trim()} data-testid="message-send-btn" className="px-5 text-[#a68966] hover:text-[#4dffb8] disabled:opacity-40 transition-colors" aria-label="Envoyer">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
        </button>
      </form>
    </div>
  );
}
